import { render, staticRenderFns } from "./MinValueErrorMessage.vue?vue&type=template&id=4dabba30&"
import script from "./MinValueErrorMessage.vue?vue&type=script&lang=js&"
export * from "./MinValueErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dabba30')) {
      api.createRecord('4dabba30', component.options)
    } else {
      api.reload('4dabba30', component.options)
    }
    module.hot.accept("./MinValueErrorMessage.vue?vue&type=template&id=4dabba30&", function () {
      api.rerender('4dabba30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Errors/MinValueErrorMessage.vue"
export default component.exports